// extracted by mini-css-extract-plugin
module.exports = {"ldsSpinner":"RoundLoader_ldsSpinner__37uft"};